import { Grid, Typography, Box, Switch, Skeleton } from "@mui/material";
import styled from "@emotion/styled";

export const SHeading = styled(Typography)({
  fontSize: "16px",
  fontWeight: 600,
  paddingLeft: "16px",
  color: "#000000",
  fontFamily: "Montserrat",
});
export const SHeading1 = styled(Typography)({
  fontSize: "14px",
  fontWeight: 600,
  paddingLeft: "16px",
  color: "#000000",
  fontFamily: "Montserrat",
});

export const SBox1 = styled(Box)({
  width: "100%",
  background: "#FFFFFF",
  margin: "16px",
  marginTop: "0px",
  marginBottom: "0px",
  padding: "8px",
  borderRadius: "5px",
});

export const SBox2 = styled(Box)({
  display: "flex",
  justifyContent: "flex-start",
});

export const SVerticalBox = styled(Box)({
  height: "61px",
  width: "5px",
  background: "#3F4ED1",
  borderRadius: "10px",
});

export const SBox3 = styled(Box)({
  paddingLeft: "16px",
  paddingRight: "16px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
  background: "#FFFFFF",
});

export const SKPIHeading = styled(Typography)({
  fontSize: "14px",
  fontWeight: 500,
  color: "#6C6C6C",
  fontStyle: "normal",
  fontFamily: "Public Sans",
});

export const SKPICount = styled(Typography)({
  fontSize: "24px",
  fontWeight: 700,
  color: "#000000",
  fontStyle: "normal",
  fontFamily: "Public Sans",
});

export const SKPISubHeading1 = styled(Typography)({
  fontSize: "14px",
  fontWeight: 400,
  color: "#848383",
  fontStyle: "normal",
  fontFamily: "Public Sans",
});

export const SKPISubHeading2 = styled(Typography)({
  fontSize: "14px",
  fontWeight: 500,
  color: "#249557",
  fontStyle: "normal",
  fontFamily: "Public Sans",
});

export const SBox4 = styled(Box)({
  margin: "4px",
  background: "#FFFFFF",
  borderRadius: "7px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexWrap: "wrap",
});

export const SGridBox = styled(Box)({
  width: "100%",
  margin: "16px",
  marginTop: "0px",
  marginBottom: "0px",
  padding: "8px",
  background: "#FFFFFF",
  //   minHeight: "460px",
  minHeight: "473.3px",
  boxShadow: "0px 2px 10px 0px rgba(0, 0, 0, 0.10)",
  borderRadius: "8px",
});

export const SGraphSubHeading = styled(Typography)({
  fontSize: "14px",
  fontWeight: 500,
  color: "#404040",
  fontStyle: "normal",
  fontFamily: "Montserrat",
  padding: "8px",
});

export const SBox5 = styled(Box)({
  padding: "8px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});

export const SUnderlineBox = styled(Box)({
  padding: "8px",
  paddingBottom: "0px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  borderBottom: "1px solid #BDC3C7",
});

export const SGHeading = styled(Typography)({
  fontSize: "20px",
  fontWeight: 600,
  color: "#000000",
  fontStyle: "normal",
  fontFamily: "Montserrat",
  paddingLeft: "10px",
});

export const SGSubHeading = styled(Typography)({
  fontSize: "12px",
  fontWeight: 600,
  color: "#848383",
  fontStyle: "normal",
  fontFamily: "Montserrat",
});

export const SGTitles = styled(Typography)({
  fontSize: "14px",
  fontWeight: 500,
  color: "#404040",
  fontStyle: "normal",
  fontFamily: "Montserrat",
  padding: "5px",
  textTransform: "capitalize"
});

export const SGToggles = styled(Typography)({
  fontSize: "16px",
  fontWeight: 500,
  color: "#404040",
  fontStyle: "normal",
  fontFamily: "Public Sans",
  padding: "8px",
});

export const TypographyList = styled(Typography)({
  fontFamily: 'Montserrat',
  fontWeight: 400,
  fontSize: '16px',
  color: '#000000'
})

export const TypographyTabHeading = styled(Typography)({
  fontFamily: 'Inter',
  fontWeight: 500,
  fontSize: '24px',
  color: '#000EDD',
  marginLeft: "18px",
  padding: "12px",
  paddingBottom: "0px"
})

export const TypographyHeading1 = styled(Typography)({
  fontFamily: 'Montserrat',
  fontWeight: 500,
  fontSize: '16px',
  color: '#000000',
  width: "100px"
})

export const TypographyHeading3 = styled(Typography)({
  fontFamily: 'Montserrat',
  fontWeight: 500,
  fontSize: '16px',
  color: '#000000',
})

export const BoxHeading1 = styled(Box)({
  minWidth: "300px",
  display: "flex",
  paddingBottom: "8px",
  paddingRight: "8px"
})

export const BoxInfoContainer1 = styled(Box)({
  maxWidth: "700px",
  marginLeft: "18px",
  padding: "12px",
  paddingTop: "4px"
})

export const BoxHeadingContainer1 = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginRight: "24px"
})

export const BoxGrid1 = styled(Box)({
  width: '100%',
  background: '#FFFFFF',
  border: '1px solid #C4C4C4',
  borderRadius: '10px',
  margin: "12px",
  minHeight: "230px"
})

export const BoxButtonContainer = styled(Box)({
  display: "flex",
  justifyContent: "flex-start",
  flexWrap: "no-wrap"
})

export const TypographyCompanyinfo = styled(Typography)({
  fontFamily: 'Montserrat',
  fontWeight: 500,
  fontSize: '14px',
  color: '#423232'
})

export const TypographyCompanyDes = styled(Typography)({
  fontFamily: 'Montserrat',
  fontWeight: 600,
  fontSize: '18px',
  color: '#848383',
  marginBottom: "8px"
})

export const BoxCompanyInfo = styled(Box)({
  padding: "24px",
  paddingBottom: "0px",
  marginTop: "-12px"
})

export const TypographyLocation = styled(Typography)({
  fontFamily: 'Inter',
  fontWeight: 400,
  fontSize: '16px',
  color: '#848383',
  marginBottom: "12px"
})

export const BoxMain2 = styled(Box)({
  paddingLeft: "12px",
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  padding: "8px",
  paddingTop: "0px"
})

export const TypographyOrg1 = styled(Typography)({
  fontFamily: 'Inter',
  fontWeight: 500,
  fontSize: '24px',
  color: '#000000',
  marginBottom: "12px"
})

export const TypographyOrg2 = styled(Typography)({
  fontFamily: 'Inter',
  fontWeight: 400,
  fontSize: '17px',
  color: '#848383'
})

export const BoxImg = styled(Box)({
  width: '161.54px',
  height: '120px',
  background: '#FFFFFF',
  border: '1px solid #C4C4C4',
  borderRadius: '10px'
})

export const BoxMain1 = styled(Box)({
  display: "flex",
  justifyContent: 'space-between',
  alignItems: 'flex-end',
  padding: "24px",
  flexWrap: "wrap",
  padding: "24px",
  marginTop: "-60px"
})

export const BoxMain3 = styled(Box)({
  display: "flex",
  justifyContent: 'space-between',
  alignItems: 'flex-end',
  flexWrap: "wrap",
  marginBottom: "8px"
})

export const TypographyHeading2 = styled(Typography)({
  fontFamily: 'Montserrat',
  fontWeight: 500,
  fontSize: '16px',
  color: '#000000',
  paddingRight: "16px"
})

export const BoxFlex1 = styled(Box)({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  width: "100%",
  marginLeft: "24px"
})

export const TypographyXs = styled(Typography)({
  fontSize: "12px",
  fontWeight: 500,
  lineHeight: "26px",
  fontFamily: "Montserrat",
  color: "#000000",
})

export const TypographySans = styled(Typography)({
  fontSize: "16px",
  fontWeight: 500,
  lineHeight: "26px",
  fontFamily: "Public Sans",
  color: "#072AC8",
})

export const ImgBox = styled(Box)({
  height: "80vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column"
})

export const TabButton = styled(Box)({
  width: "170px",
  textAlign: "center",
  cursor: "pointer",
  fontWeight: 600,
  fontFamily: "Montserrat",
  fontSize: "14px",
  padding: "4px",
  paddingBottom: "8px",
  paddingTop: "8px",
  color: "#000EDD",
  background: "#E0E0E0",
  borderBottom: "4px solid #000EDD",
});

export const TabButtonLeft = styled(Box)({
  width: "170px",
  textAlign: "center",
  cursor: "pointer",
  fontWeight: 600,
  fontFamily: "Montserrat",
  fontSize: "14px",
  padding: "4px",
  paddingBottom: "8px",
  paddingTop: "8px",
  color: "#000EDD",
  background: "#E0E0E0",
  borderBottom: "4px solid #000EDD",
  borderBottomLeftRadius: "10px",
});

export const TabButtonClick = styled(Box)({
  width: "170px",
  textAlign: "center",
  cursor: "pointer",
  fontFamily: "Montserrat",
  fontSize: "14px",
  fontWeight: 600,
  padding: "4px",
  paddingBottom: "8px",
  paddingTop: "8px",
  color: "#423232",
  background: "#FFFFFF",
  borderBottom: "4px solid #DDDDDD",
});

export const TabButtonClickLeft = styled(Box)({
  width: "170px",
  textAlign: "center",
  cursor: "pointer",
  fontFamily: "Montserrat",
  fontSize: "14px",
  fontWeight: 600,
  padding: "4px",
  paddingBottom: "8px",
  paddingTop: "8px",
  color: "#423232",
  background: "#FFFFFF",
  borderBottom: "4px solid #DDDDDD",
  borderBottomLeftRadius: "10px",
});
